import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Layout from "./components/Layout"
import HomePage from "./components/HomePage"
import VideosPage from "./components/VideosPage"
import ShopPage from "./components/ShopPage"
import ParentsPage from "./components/ParentsPage"
import EbooksPage from "./components/EbooksPage"
import ClothingPage from "./components/ClothingPage"
import PuzzlesPage from "./components/PuzzlesPage"
import ColorPlayLearnPage from "./components/ColorPlayLearnPage"
import NurseryGearPage from "./components/NurseryGearPage"
import DailyMustHavesPage from "./components/DailyMustHavesPage"
import AboutPage from "./components/AboutPage"

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/parents" element={<ParentsPage />} />
          <Route path="/shop/ebooks" element={<EbooksPage />} />
          <Route path="/shop/clothing" element={<ClothingPage />} />
          <Route path="/shop/puzzles" element={<PuzzlesPage />} />
          <Route path="/shop/color-play-learn" element={<ColorPlayLearnPage />} />
          <Route path="/parents/nursery-gear" element={<NurseryGearPage />} />
          <Route path="/parents/daily-must-haves" element={<DailyMustHavesPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App
